import type { KanbanComment } from '../comment/interfaces'
import type { KanbanCommentsStore } from './interfaces'

export const actions = {
  setLoading (this: KanbanCommentsStore, payload: KanbanCommentsStore['loading']): void {
    this.loading = payload
  },

  setComments (this: KanbanCommentsStore, payload: KanbanCommentsStore['comments']): void {
    this.comments = payload
  },

  setCustomerId (this: KanbanCommentsStore, payload: KanbanCommentsStore['customerId']): void {
    this.customerId = payload
  },

  addComment (this: KanbanCommentsStore, payload: KanbanComment): void {
    this.comments = [payload, ...this.comments]
  },

  updateComment (this: KanbanCommentsStore, payload: KanbanComment): void {
    this.comments = this.comments.map(comment => comment.id === payload.id ? payload : comment)
  },

  removeComment (this: KanbanCommentsStore, payload: KanbanComment['id']): void {
    this.comments = this.comments.filter(comment => comment.id !== payload)
  },

  resetComments (this: KanbanCommentsStore): void {
    this.comments = []
    this.customerId = null
  },
}